import { Button } from "antd";
import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import FilterableTableLayout from "../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../modules/filters/filters.types";
import {
  EXCISE_LICENCE_INITIAL_FILTERS,
  getExciseLicenceRequestFilterItems,
  getExciseLicenceRequestTableColumns,
} from "../../../modules/obligee/exciseLicences/exciseLicences.constants";
import { ExciseLicencesContext } from "../../../modules/obligee/exciseLicences/exciseLicences.context";
import { useExciseLicenceRequestList } from "../../../modules/obligee/exciseLicences/exciseLicences.queries";
import {
  ExciseLicenceRequest,
  ExciseLicenceRequestListPayload,
  ExciseLicenceRequestListResponse,
} from "../../../modules/obligee/exciseLicences/exciseLicences.types";

const ExciseLicenceRequestList = observer(() => {
  const navigate = useNavigate();
  const { setExciseLicences } = useContext(ExciseLicencesContext);

  const handleAddNewExciseLicenceRequest = () => {
    navigate("/obveznik/akcizneDozvole/noviZahtev");
  };

  const onTableRowClickHandler = (record: ExciseLicenceRequest) => {
    setExciseLicences({ selectedDozvolaId: record.id });

    navigate(
      `/obveznik/akcizneDozvole/detaljiDozvola?id=${record.id}&tipZahteva=${record.tipZahteva}`
    );
  };

  return (
    <FilterableTableLayout<
      ExciseLicenceRequest,
      ExciseLicenceRequestListResponse,
      ExciseLicenceRequestListPayload
    >
      tableName="excise_licence_request_table"
      dataListKey="exciseLicenceRequestList"
      toolbarId="excise_licence_request_list"
      title={t("AKCIZNE_MARKICE.LISTA_AKCIZNIH_DOZVOLA")}
      filterProps={{
        getFilterItems: getExciseLicenceRequestFilterItems,
        initialFilters: EXCISE_LICENCE_INITIAL_FILTERS,
        persistedFilterKey: PersistedFilterKeys.EXCISE_LICENCE_REQUEST_LIST,
      }}
      getTableColumns={getExciseLicenceRequestTableColumns}
      queryHook={useExciseLicenceRequestList}
      tableRowKey="id"
      onTableRowClick={onTableRowClickHandler}
      toolbarActions={
        <Button type="primary" onClick={handleAddNewExciseLicenceRequest}>
          {t("AKCIZNE_MARKICE.NOVI_ZAHTEV")}
        </Button>
      }
    />
  );
});

export default ExciseLicenceRequestList;
